// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_nhx","rootMobile":"styles_rootMobile__2RCxV"};